import { useState } from "react";
import { Divider, Flex } from "antd";
import { Button, LexicalEditor } from "ui";
import { useGetTerms, useUpdateTerms } from "../api";

export const TermsManagement = () => {
  const [text, setText] = useState<string>("");

  const { data } = useGetTerms();
  const { mutate, isPending: updating } = useUpdateTerms();

  return (
    <div className="box">
      <h1>قوانین استفاده از وبسایت</h1>
      <Divider />
      <LexicalEditor
        onChange={(html: string) => setText(html)}
        value={data?.data ?? ""}
      />
      <Divider />
      <Flex justify="flex-end" gap={10}>
        <Button size="large">لغو کردن</Button>
        <Button
          type="primary"
          size="large"
          loading={updating}
          onClick={() => mutate({ text })}
        >
          ذخیره تغییرات
        </Button>
      </Flex>
    </div>
  );
};
